import { TuiDay, TuiTime } from '@taiga-ui/cdk';
import { DateTime } from 'luxon';

import { assertValid } from './luxon/luxon.fns';

// Todo: Clean up, split to separate files, add unit tests, group into DateHelper?, docs

/**
 * @deprecated Use {@link toIsoDatetimeString} instead.
 */
export function isoDate(day: TuiDay | null, time: TuiTime | null): string {
  return day
    ? new Date(day.year, day.month, day.day, time?.hours ?? 0, time?.minutes ?? 0, time?.seconds ?? 0).toISOString()
    : '';
}

/**
 * Returns the current day as ISO 8601 **date** string **without time zone**.
 * @param timeZone Time zone where the current day should be determined. When not given, the system's time zone is used.
 */
export function currentDate(timeZone: string = getTimeZone()): string {
  const today = DateTime.local({ zone: timeZone }).startOf('day');
  return today.toISODate();
}

/**
 * @deprecated Use {@link fromIsoToTuiDay} instead.
 *
 * Transforms a string to a {@link TuiDay}.
 *
 * @param date - The date as string to transform
 */
export function toTuiDay(date: string): TuiDay {
  const parsed = assertValid(DateTime.fromISO(date));
  return new TuiDay(parsed.year, parsed.month - 1, parsed.day);
}

/**
 * @deprecated Use {@link fromIsoToTuiTime} instead.
 *
 * Transforms a string to a {@link TuiTime}.
 *
 * @param time - The time as string to transform
 */
export function toTuiTime(time: string): TuiTime {
  const parsed = assertValid(DateTime.fromISO(time));
  return new TuiTime(parsed.hour, parsed.minute, parsed.second, parsed.millisecond);
}

/**
 * Gets the name of the system's time zone.
 *
 * @returns the time zone name (e.g. America/Sao_Paulo)
 */
export function getTimeZone(): string {
  return DateTime.local().zoneName;
}

/**
 * Converts date from source time zone to target time zone
 * and returns the date in UTC representation.
 * By default the system's time zone is used as source time zone.
 *
 * @param dateTime the ISO date string e.g. (2023-11-22T03:00:00.000Z)
 * @param targetTimeZone the target time zone e.g. (Europe/Berlin)
 * @param sourceTimeZone the original time zone e.g. (America/Sao_Paulo), defaults to system timezone
 * @returns the date in target time zone e.g. (2023-11-21T23:00:00.000Z)
 */
export function convertDateTimeToTimeZone(
  dateTime: string,
  targetTimeZone: string,
  sourceTimeZone: string = getTimeZone(),
): string {
  if (dateTime) {
    const convertedDate = DateTime.fromISO(dateTime, { zone: sourceTimeZone })
      .setZone(targetTimeZone, { keepLocalTime: true })
      .toUTC();
    if (convertedDate.isValid) {
      return convertedDate.toString();
    }
    throw new Error(
      `Could not convert ${dateTime} from ${sourceTimeZone} to ${targetTimeZone}: ${convertedDate.invalidExplanation}`,
    );
  }
  return dateTime;
}
